// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"1d8d6a74","60":"a9662ba0"}[chunkId] + ".chunk.css";
};